<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="220px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" :clearable="true" style="width:217px"></el-input>
      </el-form-item>
      <el-form-item label="副标题" prop="subtitle">
        <el-input
          v-model="form.subtitle"
          placeholder="请输入副标题"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item label="限制参与证书" prop="certIds" required>
        <el-select class="filter-item" multiple v-model="form.certIds" placeholder="请选择限制参与证书">
          <el-option v-for="item in certIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker v-model="form.startTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" required prop="endTime">
        <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
      </el-form-item>
      <el-form-item
        label="活动名称"
        prop="name"
        :rules="[
        { required: true, message: '请输入活动名称', trigger: 'blur' }
      ]"
      >
        <el-input v-model="form.name" placeholder="请输入标题" :clearable="true" style="width:217px"></el-input>
      </el-form-item>
      <el-form-item
        label="初始机会券数量"
        required
        prop="defaultCount"
        :rules="[
        { required: true, message: '初始机会券数量不能为空', trigger: 'blur' },
        { type: 'number', message: '初始机会券数量必须为数字值' },
        { pattern: /^[1-9]+[0-9]*$|^0$/, message: '非负整数（正整数 + 0）',trigger: 'blur'}
      ]"
      >
        <el-input
          v-model.number="form.defaultCount"
          placeholder="请输入初始机会券数量"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item label="兑换比例-成长币" required prop="convertibleGrowing">
        <el-input
          v-model.number="form.convertibleGrowing"
          placeholder="请输入兑换比例成长币"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item label="兑换比例-机会券" required prop="convertibleTicket">
        <el-input
          v-model.number="form.convertibleTicket"
          placeholder="请输入兑换比例机会券"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item label="机会券名称" required prop="ticketName">
        <el-input
          v-model="form.ticketName"
          placeholder="请输入机会券名称"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="机会券图标"
        required
        prop="ticketIcon"
        :rules="[
        { required: true, message: '请上传机会券图标', trigger: 'change' },]"
      >
        <uploadImg v-model="form.ticketIcon" :max="1" :text="['图片大小500kb以内']"></uploadImg>
      </el-form-item>
      <el-form-item label="开启免费领取" prop="sendTicket">
        <el-select v-model="form.sendTicket" clearable placeholder="请选择是否开启免费领取">
          <el-option
            v-for="item in sendTicketList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="免费领取间隔" required prop="sendTicketInterval">
        <el-input
          v-model.number="form.sendTicketInterval"
          placeholder="请输入免费领取间隔时长(单位/小时)"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="背景图片"
        required
        prop="backImg"
        :rules="[
        { required: true, message: '请上传背景图片', trigger: 'change' },]"
      >
        <uploadImg v-model="form.backImg" :max="1" :text="['图片大小500kb以内']"></uploadImg>
      </el-form-item>
      <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
        <div
          style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "
        >任务卡片</div>
        <el-collapse accordion>
          <el-collapse-item v-for="(item, index) in form.gifts" :key="index">
            <span style="font-size:15px;font-weight:600; margin:20px;" slot="title">
              任务卡片{{index + 1}}, [委托方名称： {{item.companyName}} , 酬劳:{{item.reward}},等级:
              <span
                v-if="item.subGrade == 0"
              >N,</span>
              <span v-if="item.subGrade == 1">R,</span>
              <span v-if="item.subGrade == 2">SR,</span>
              <span v-if="item.subGrade == 3">SSR,</span>
              <span v-if="item.subGrade == 4">ER,</span>

              <span>概率: {{item.num}}%,</span>
              <span v-if="item.dynamicProbability == 1">已开启动态概率</span>
              ]
            </span>
            <el-form-item
              label="奖品名称"
              required
              :prop="'gifts.' + index + '.name'"
              :rules="rules.name"
            >
              <el-input v-model="item.name" placeholder="请输入奖品名称" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item
              label="奖品可抽取份数"
              required
              :prop="'gifts.' + index + '.limitCount'"
              :rules="rules.limitCount"
            >
              <el-input v-model="item.limitCount" placeholder="请输入奖品可抽取份数" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item
              label="虚拟可抽取数量"
              :prop="'gifts.' + index + '.virtualLimitCount'"
              :rules="rules.virtualLimitCount"
            >
              <el-input v-model="item.virtualLimitCount" placeholder="虚拟可抽取数量" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item
              label="虚拟已抽取数量"
              :prop="'gifts.' + index + '.virtualDrawCount'"
              :rules="rules.virtualDrawCount"
            >
              <el-input v-model="item.virtualDrawCount" placeholder="虚拟已抽取数量" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item
              label="领取概率(百分值)"
              required
              :prop="'gifts.' + index + '.probability'"
              :rules="rules.probability"
            >
              <el-input v-model="item.probability" placeholder="请输入领取概率" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="开启动态概率" required :prop="'gifts.' + index + '.dynamicProbability'">
              <el-radio-group v-model="item.dynamicProbability">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="item.dynamicProbability == 1"
              label="递减数值(百分值)"
              :prop="'gifts.' + index + '.reduceStep'"
              required
              :rules="[
            { required: true, message: '请填写递减数值', trigger: 'blur' },
            ]"
            >
              <el-input v-model="item.reduceStep" placeholder="请输入递减数值" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item
              v-if="item.dynamicProbability == 1"
              label="最低概率(百分值)"
              required
              :prop="'gifts.' + index + '.lowestProbability'"
              :rules="[
            { required: true, message: '请填写最低概率', trigger: 'blur' },
            ]"
            >
              <el-input v-model="item.lowestProbability" placeholder="请输入最低概率" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="开启必中" required :prop="'gifts.' + index + '.openInfallible'">
              <el-radio-group v-model="item.openInfallible">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="可兑换经验值数量"
              required
              :prop="'gifts.' + index + '.convertiblePointCount'"
              :rules="[
            { required: true, message: '请填写经验值数量', trigger: 'blur' },
            { type: 'number', message: '经验值数量必须为数字值' },
            ]"
            >
              <el-input
                v-model.number="item.convertiblePointCount"
                placeholder="请输入经验值数量"
                :clearable="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="必中时机( 请输入第几次必中 )" required v-if="item.openInfallible == 1">
              <div v-for="(item2,index2) in item.infallibleTimesList2" :key="index2">
                <el-input
                  placeholder="请输入第几次必中"
                  v-model="item2.infallibleTimew"
                  style="width: 100px;"
                  size="small"
                ></el-input>
                <el-button
                  class="btns"
                  type="primary"
                  size="small"
                  v-if="index2 == 0"
                  @click="getOpportunity(index,index2)"
                >添加</el-button>
                <i
                  class="el-icon-delete"
                  type="danger"
                  size="small"
                  @click="getClosety(index,index2)"
                  v-if="index2 != 0"
                ></i>
              </div>
            </el-form-item>
            <el-form-item label="情景故事">
              <uploadIms
                @changed="changes"
                :trues="true"
                :index1="index"
                :filterManage.sync="item.drawingImgs"
              ></uploadIms>
            </el-form-item>
            <el-form-item
              label="酬劳"
              required
              :prop="'gifts.' + index + '.reward'"
              :rules="rules.reward"
            >
              <el-input v-model="item.reward" placeholder="请输入酬劳" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item
              label="背景图"
              required
              :prop="'gifts.' + index + '.backImg'"
              :rules="[
            { required: true, message: '请上传背景图', trigger: 'change' },
            ]"
            >
              <uploadImg v-model="item.backImg" :max="1" :text="['图片大小500kb以内']"></uploadImg>
            </el-form-item>
            <el-form-item
              label="边框图"
              required
              :prop="'gifts.' + index + '.borderImg'"
              :rules="[
            { required: true, message: '请上传边框图', trigger: 'change' },
            ]"
            >
              <uploadImg v-model="item.borderImg" :max="1" :text="['图片大小500kb以内']"></uploadImg>
            </el-form-item>
            <el-form-item
              label="等级背景"
              required
              :prop="'gifts.' + index + '.gradeImg'"
              :rules="[
            { required: true, message: '请上传等级背景', trigger: 'change' },
            ]"
            >
              <uploadImg v-model="item.gradeImg" :max="1" :text="['图片大小500kb以内']"></uploadImg>
            </el-form-item>
            <el-form-item
              label="等级"
              required
              :prop="'gifts.' + index + '.subGrade'"
              :rules="rules.subGrade"
            >
              <el-select class="filter-item" v-model="item.subGrade" clearable placeholder="请选择等级">
                <el-option
                  v-for="itemss in subGradeList"
                  :key="itemss.key"
                  :label="itemss.value"
                  :value="itemss.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="子等级"
              required
              :prop="'gifts.' + index + '.grade'"
              :rules="rules.grade"
            >
              <el-select class="filter-item" v-model="item.grade" clearable placeholder="请选择子等级">
                <el-option
                  v-for="itemss in gradeList"
                  :key="itemss.key"
                  :label="itemss.value"
                  :value="itemss.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="类型"
              required
              :prop="'gifts.' + index + '.type'"
              :rules="rules.type"
            >
              <el-input v-model="item.type" placeholder="请输入类型" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item
              label="委托方名称"
              required
              :prop="'gifts.' + index + '.companyName'"
              :rules="rules.companyName"
            >
              <el-input v-model="item.companyName" placeholder="请输入委托方名称" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item
              label="委托方图标"
              required
              :prop="'gifts.' + index + '.companyIcon'"
              :rules="[
            { required: true, message: '请上传委托方图标', trigger: 'change' },
            ]"
            >
              <uploadImg v-model="item.companyIcon" :max="1" :text="['图片大小500kb以内']"></uploadImg>
            </el-form-item>
            <el-form-item
              label="颜色"
              required
              :prop="'gifts.' + index + '.color'"
              :rules="rules.color"
            >
              <el-color-picker v-model="item.color" size="mini"></el-color-picker>
            </el-form-item>
            <el-form-item
              label="打卡活动"
              required
              :prop="'gifts.' + index + '.clockThemeId'"
              :rules="rules.clockThemeId"
            >
              <el-select
                class="filter-item"
                v-model="item.clockThemeId"
                clearable
                placeholder="请选择打卡活动"
                filterable
              >
                <el-option
                  v-for="item in clockThemeList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="图标"
              required
              :prop="'gifts.' + index + '.icon'"
              :rules="[
            { required: true, message: '请上传图标', trigger: 'change' },
            ]"
            >
              <uploadImg v-model="item.icon" :max="1" :text="['图片大小500kb以内']"></uploadImg>
            </el-form-item>
            <div
              style="border:1px solid #DCDFE6;width:98%;padding:0 0 20px 0;margin: 0px auto;margin-bottom: 20px;"
            >
              <div style="text-align: center;margin: 20px auto;">能力限制</div>
              <div
                v-for="(item2, index2) in item.attrLimitList"
                :key="index2"
                style="margin-top: 20px;"
              >
                <el-form-item
                  label="属性类型"
                  required
                  :prop="'gifts.'+index+'.attrLimitList.'+index2+'.attrId'"
                  :rules="{ required: true, message: '请选择属性类型', trigger: 'change' }"
                >
                  <el-select v-model="item2.attrId" placeholder="请选择">
                    <el-option-group
                      v-for="group in options"
                      :key="group.label"
                      :label="group.label"
                    >
                      <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="门槛类型"
                  required
                  :rules="{ required: true, message: '请选择门槛类型', trigger: 'change' }"
                  :prop="'gifts.'+index+'.attrLimitList.'+index2+'.type'"
                >
                  <el-select
                    class="filter-item"
                    v-model="item2.type"
                    clearable
                    placeholder="请选择选择门槛类型"
                  >
                    <el-option
                      v-for="items in typeList"
                      :key="items.key"
                      :label="items.value"
                      :value="items.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="门槛值"
                  required
                  :prop="'gifts.'+index+'.attrLimitList.'+index2+'.value'"
                  :rules="[
                { required: true, message: '奖品数量不能为空', trigger: 'blur' },
                { type: 'number', message: '奖品数量必须为数字值' },
                    { pattern: /^[1-9]+[0-9]*$|^0$/, message: '非负整数（正整数 + 0）',trigger: 'blur'}
                ]"
                >
                  <el-input
                    v-model.number="item2.value"
                    placeholder="请输入门槛值"
                    :clearable="true"
                    style="width:217px"
                  ></el-input>
                </el-form-item>
                <div style="display: flex;justify-content: center;">
                  <el-button type="primary" size="mini" @click="addPrize(index,index2)">+增加能力限制</el-button>
                  <el-button
                    type="danger"
                    size="mini"
                    @click="removePrize(index,index2)"
                    v-if="index2 !== 0"
                  >-删除能力限制</el-button>
                </div>
              </div>
            </div>
            <div style="text-align: center;margin-bottom: 30px;">
              <!-- <el-button type="primary" size="mini" @click="addList()">添加任务卡片</el-button> -->
              <el-button
                type="danger"
                size="mini"
                @click="removeList(index)"
                v-if="index !== 0"
              >删除任务卡片</el-button>
            </div>
          </el-collapse-item>
          <div style="text-align: center;margin-bottom: 30px;">
            <el-button type="primary" size="mini" @click="addList()">添加任务卡片</el-button>
            <!-- <el-button
              type="danger"
              size="mini"
              @click="removeList(index)"
              v-if="index !== 0"
            >删除任务卡片</el-button>-->
          </div>
        </el-collapse>
      </div>
      <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
        <div
          v-for="(item3,index3) in form.skips"
          :key="index3"
          style="margin: 0px auto;margin-top: 20px; width:98%;border:1px solid"
        >
          <div
            style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "
          >跳转模块</div>
          <el-form-item
            label="图片"
            required
            :prop="'skips.' + index3 + '.img'"
            :rules="[
            { required: true, message: '请上传图片', trigger: 'change' },
            ]"
          >
            <uploadImg v-model="item3.img" :max="1" :text="['图片大小500kb以内']"></uploadImg>
          </el-form-item>
          <el-form-item label="跳转地址" required>
            <jumpType2 :Jumpurls="item3.Jumpurl"></jumpType2>
          </el-form-item>
          <div style="display: flex;justify-content: center;margin-bottom:20px">
            <el-button type="primary" size="mini" @click="addjumpModal(index3)">+增加跳转模块</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="removejumpModal(index3)"
              v-if="index3 !== 0"
            >-删除跳转模块</el-button>
          </div>
        </div>
      </div>
    </el-form>
    <div class="footer" v-if="IncreaseAndChange || nameId == '复制'">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定2</el-button>
    </div>
    <div class="footer" v-else>
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="success" @click="getModify('form')">确 定</el-button>
    </div>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { certList } from '@/api/demo/close/index'
import uploadImg from '@/components/uploadImage/index.vue'
import uploadIms from '@/components/uploadImage/index.vue'
import { getToken } from '@/api/demo/classification/index'
import {
  getAddCRAct,
  getCRInfo,
  getCRUpdate
} from '@/api/demo/CommissionRelate/index'
import { getThemeList } from '@/api/demo/punchInActivity/index'
import { attList } from '@/api/demo/attributes/index'
import jumpType2 from '@/components/jumpType/jumpType.vue'
import moment from 'moment'
import draggable from 'vuedraggable'
export default {
  name: 'addToCR',
  components: {
    uploadImg,
    uploadIms,
    jumpType2,
    draggable
  },
  data () {
    var GrowNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('成长币不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'))
        } else {
          callback()
        }
      }, 200)
    }
    var TicketNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('机会券不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'))
        } else {
          callback()
        }
      }, 200)
    }
    var intervalCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('领取间隔时长不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'))
        } else {
          callback()
        }
      }, 200)
    }
    return {
      nameId: '',
      // 七牛上传图片
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },
      https: null,
      listLoading: true, // 加载圈圈
      indexId: null,
      IncreaseAndChange: true, // 判断是新增还是修改
      activity: null, // 修改需要的活动id
      /** 模板配置 */
      tplOptions: {
        sort: true
      },
      form: {
        title: '', // 标题
        subtitle: '', // 副标题
        certIds: [], // 限制参与证书
        name: '', // 活动名称
        defaultCount: '', // 初始机会券数量
        convertibleGrowing: '', // 成长币
        convertibleTicket: '', // 机会券
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        sendTicket: '', // 是否开启免费领取
        sendTicketInterval: '', // 免费领取间隔时间
        gifts: [
          {
            backImg: '', // 封面图
            backImg2: [], // 封面图
            borderImg2: [], // 边框图
            borderImg: '', // 边框图
            clockThemeId: '', // 打卡活动id
            color: '', // 颜色
            companyName: '', // 委托方名称
            companyIcon: '', // 委托方图标
            companyIcon2: [], // 委托方图标
            attrLimitList: [
              {
                attrId: '', // 属性类型id
                type: '', // 门槛类型
                value: '' // 门槛值
              }
            ], // 奖品集合
            grade: '', // 等级
            gradeImg2: [], // 等级背景
            gradeImg: '', // 等级背景
            subGrade: '', // 子等级
            icon: '', // 图标
            icon2: [], // 图标
            limitCount: '', // 奖品可抽取份数
            virtualLimitCount: 0, // 虚拟可抽取数量
            virtualDrawCount: 0, // 虚拟已抽取数量
            name: '', // 名称
            probability: '', // 领取概率
            dynamicProbability: 0, // 开启概率
            openInfallible: 0, // 开启必中
            convertiblePointCount: 0, // 可兑换的经验值数量
            infallibleTimesList2: [{ infallibleTimew: '' }], // 必中时机
            story: '',
            drawingImgs: [], // 情景图
            infallibleTimesList: [],
            lowestProbability: '', // 最低概率
            reduceStep: '', // 递减概率
            reward: '', // 酬劳
            type: '' // 类型
          }
        ],
        // status: "",              //0 未开始 1 进行中 2 已结束 3已关闭
        ticketName: '', // 机会券名称
        ticketIcon2: [], // 机会券图标
        ticketIcon: '', // 机会券图标
        skips: [
          // 跳转模块
          {
            img: '', // 图片
            img2: [],
            paramType: '', // 参数类型
            paramValue: '', // 参数值
            skipLink: '', // 跳转地址
            skipType: '', // 跳转类型
            Jumpurl: {
              url: null,
              id: null,
              classId: null,
              paramType: '0',
              value: ''
            }
          }
        ]
      },
      clockThemeList: [], // 打卡活动
      statusList: [
        // 状态
        {
          key: 0,
          value: '未开始'
        },
        {
          key: 1,
          value: '进行中'
        },
        {
          key: 2,
          value: '已结束'
        },
        {
          key: 3,
          value: '已关闭'
        }
      ],
      gradeList: [
        // 子等级
        {
          key: 0,
          value: '普通级'
        },
        {
          key: 1,
          value: '学徒级'
        },
        {
          key: 2,
          value: '精英级'
        },
        {
          key: 3,
          value: '专家级'
        },
        {
          key: 4,
          value: '大师级'
        }
      ],
      subGradeList: [
        // 等级
        {
          key: 0,
          value: 'N'
        },
        {
          key: 1,
          value: 'R'
        },
        {
          key: 2,
          value: 'SR'
        },
        {
          key: 3,
          value: 'SSR'
        },
        {
          key: 4,
          value: 'ER'
        }
      ],
      typeList: [
        {
          key: 0,
          value: '分数'
        },
        {
          key: 1,
          value: '等级'
        }
      ],
      sendTicketList: [
        {
          key: 0,
          value: '关闭'
        },
        {
          key: 1,
          value: '开启'
        }
      ],
      options: [
        { label: '能力属性', options: [] },
        { label: '影响力属性', options: [] }
      ],
      rules: {
        name: [{ required: true, message: '请输入奖品名称', trigger: 'blur' }],
        limitCount: [
          { required: true, message: '请输入奖品可抽取份数', trigger: 'blur' }
        ],
        certIds: [
          { required: true, message: '请选择亲密证书', trigger: 'change' }
        ],
        virtualLimitCount: [
          { required: true, message: '请输入虚拟可抽取数量', trigger: 'blur' }
        ],
        virtualDrawCount: [
          { required: true, message: '请输入虚拟已抽取数量', trigger: 'blur' }
        ],
        probability: [
          { required: true, message: '请输入领取概率(百分值)', trigger: 'blur' }
        ],
        lowestProbability: [
          { require: true, message: '请输入最低概率(百分值)', trigger: 'blur' }
        ],
        reduceStep: [
          { require: true, message: '请输入递减概率(百分值)', trigger: 'blur' }
        ],
        reward: [{ required: true, message: '请输入酬劳', trigger: 'blur' }],
        color: [{ required: true, message: '请选择颜色', trigger: 'change' }],
        grade: [{ required: true, message: '请选择子等级', trigger: 'change' }],
        subGrade: [
          { required: true, message: '请选择等级', trigger: 'change' }
        ],
        type: [{ required: true, message: '请输入类型', trigger: 'blur' }],
        companyName: [
          { required: true, message: '请输入委托方名称', trigger: 'blur' }
        ],
        clockThemeId: [
          { required: true, message: '请选择打卡活动', trigger: 'change' }
        ],
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur'
          }
        ],
        subtitle: [
          {
            required: true,
            message: '请输入副标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur'
          }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ],
        sendTicket: [
          {
            required: true,
            message: '请选择是否开启免费领取',
            trigger: 'change'
          }
        ],
        sendTicketInterval: [{ validator: intervalCheck, trigger: 'blur' }],
        convertibleGrowing: [{ validator: GrowNum, trigger: 'blur' }],
        convertibleTicket: [{ validator: TicketNum, trigger: 'blur' }],
        ticketName: [
          {
            required: true,
            message: '请输入机会券',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur'
          }
        ]
      },
      certIdList: [], // 证书集合
      listQuery: {
        currentPage: 1,
        pageSize: 1000
      }
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  watch: {
    $route (to, from) {}
  },
  created () {
    let that = this
    this.getSearch() // 证书集合
    let id = this.$route.query.id
    this.nameId = this.$route.query.name
    that.activity = this.$route.query.id
    if (id != undefined) {
      that.IncreaseAndChange = false
      getCRInfo(id).then(res => {
        var sum = 0
        for (let index = 0; index < res.gifts.length; index++) {
          sum += parseInt(res.gifts[index].probability)
          if (this.nameId == '复制') {
            res.gifts[index].id = null
          }
          if (res.gifts[index].story == null) {
            res.gifts[index].drawingImgs = []
            // return;
          } else {
            res.gifts[index].drawingImgs = res.gifts[index].story.split(',')
          }

          if (res.gifts[index].openInfallible == 0) {
            res.gifts[index].infallibleTimesList2 = [{ infallibleTimew: '' }]
          } else if (res.gifts[index].openInfallible == 1) {
            res.gifts[index].infallibleTimesList2 = []
            res.gifts[index].infallibleTimesList.forEach(element => {
              res.gifts[index].infallibleTimesList2.push({
                infallibleTimew: element
              })
            })
          }
        }
        res.gifts.forEach((item, index) => {
          item.num = ((item.probability / sum) * 100).toFixed(2)
        })
        res.skips.map(item => {
          if (parseInt(item.paramType) == 1) {
            item.paramValue = parseInt(item.paramValue)
          }

          item.Jumpurl = {
            url: item.skipLink,
            id: parseInt(item.skipType),
            classId: null,
            paramType: item.paramType,
            value: item.paramValue
          }
        })
        that.form = res
      })
    }
  },
  mounted () {
    let that = this
    that.getAttributes()
    that.getActList()
  },
  methods: {
    // 获取打卡活动id
    getActList () {
      getThemeList(this.listQuery).then(res => {
        res.records.forEach(item => {
          this.clockThemeList.push({
            key: item.id,
            value: item.title
          })
        })
      })
    },
    // 获取属性相关
    getAttributes () {
      attList(this.listQuery, 4).then(res => {
        res.records.forEach(item => {
          this.options[0].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(this.listQuery, 5).then(res => {
        res.records.forEach(item => {
          this.options[1].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
    },
    // 查询证书列表
    getSearch () {
      let that = this
      certList(that.listQuery).then(res => {
        that.listLoading = true
        that.certIdList = res.records
        that.listLoading = false
      })
    },
    // 取消
    cancel () {
      let that = this
      that.$router.push('/demo/CommissionRelate')
    },
    // 新增
    getCreate (forms) {
      // console.log('that.form.gifts1',that.form.gifts)
      let that = this
      that.form.gifts.forEach((item, index) => {
        if (
          item.openInfallible == 1 &&
          item.infallibleTimesList2.infallibleTimew != ''
        ) {
          item.infallibleTimesList = []
          item.infallibleTimesList2.forEach((item2, index2) => {
            item.infallibleTimesList.push(item2.infallibleTimew)
          })
        } else if (
          item.openInfallible == 1 &&
          item.infallibleTimesList2.infallibleTimew == ''
        ) {
          that.$notify({
            title: '失败',
            message: '请填写奖品名称为:' + item.name + '所对应的必中时机',
            type: 'error',
            duration: 3000
          })
        }
      })
      this.$refs[forms].validate(valid => {
        if (valid) {
          that.form.gifts.forEach((item, index) => {
            item.story = item.drawingImgs.join(',')
            if (
              item.openInfallible == 1 &&
              item.infallibleTimesList2.length > 0
            ) {
              item.infallibleTimesList = []
              item.infallibleTimesList2.forEach((item2, index2) => {
                item.infallibleTimesList.push(item2.infallibleTimew)
              })
            } else if (
              item.openInfallible == 1 &&
              item.infallibleTimesList2.length == 0
            ) {
              that.$notify({
                title: '失败',
                message: '请填写奖品名称为:' + item.name + '所对应的必中时机',
                type: 'error',
                duration: 3000
              })
            }
          })
          that.form.startTime = moment(that.form.startTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          that.form.endTime = moment(that.form.endTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          that.form.skips.map(item => {
            (item.img = item.img2.join(',')),
            (item.paramType = item.Jumpurl.paramType),
            (item.paramValue = item.Jumpurl.value),
            (item.skipType = item.Jumpurl.id),
            (item.skipLink = item.Jumpurl.url)
          })
          getAddCRAct(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/CommissionRelate')
          })
        }
      })
    },
    // 修改
    getModify (forms) {
      let that = this
      console.log('that.form.gifts2', that.form.gifts)
      that.form.gifts.forEach((item, index) => {
        console.log('index', index, item)
        if (
          item.openInfallible == 1 &&
          item.infallibleTimesList2.infallibleTimew != ''
        ) {
          item.infallibleTimesList = []
          item.infallibleTimesList2.forEach((item2, index2) => {
            item.infallibleTimesList.push(item2.infallibleTimew)
          })
        } else if (
          item.openInfallible == 1 &&
          item.infallibleTimesList2.infallibleTimew == ''
        ) {
          that.$notify({
            title: '失败',
            message: '请填写奖品名称为:' + item.name + '所对应的必中时机',
            type: 'error',
            duration: 3000
          })
        } else {
        }
      })
      this.$refs[forms].validate(valid => {
        if (valid) {
          that.form.startTime = moment(that.form.startTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          that.form.endTime = moment(that.form.endTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          that.form.skips.map(item => {
            (item.paramType = item.Jumpurl.paramType),
            (item.paramValue = item.Jumpurl.value),
            (item.skipType = item.Jumpurl.id),
            (item.skipLink = item.Jumpurl.url)
          })
          getCRUpdate(that.form, that.activity).then(res => {
            that.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/CommissionRelate')
          })
        } else {
          return false
        }
      })
    },
    changes (data, index) {
      let that = this
      that.form.gifts[index].drawingImgs = data
      console.log('data', data, index, that.form.gifts)
    },
    // 点击添加
    addList () {
      this.form.gifts.push({
        backImg: '', // 封面图
        backImg2: [], // 封面图
        borderImg2: [], // 边框图
        borderImg: '', // 边框图
        companyName: '', // 委托方名称
        companyIcon: '', // 委托方图标
        companyIcon2: [], // 委托方图标
        attrLimitList: [
          {
            attrId: '', // 属性类型id
            type: '', // 门槛类型
            value: '' // 门槛值
          }
        ], // 奖品集合
        color: '', // 颜色
        grade: '', // 等级
        gradeImg2: [], // 等级背景
        gradeImg: '', // 等级背景
        subGrade: '', // 子等级
        clockThemeId: '', // 打卡活动id
        icon: '', // 图标
        icon2: [], // 图标
        limitCount: '', // 奖品可抽取份数
        virtualLimitCount: 0, // 虚拟已抽取数量
        virtualDrawCount: 0, // 虚拟可抽取数量
        name: '', // 名称
        probability: '', // 领取概率
        dynamicProbability: 0, // 开启概率
        openInfallible: 0, // 开启必中
        convertiblePointCount: 0, // 可兑换的经验值数量
        infallibleTimesList2: [{ infallibleTimew: '' }], // 必中时机
        story: '',
        drawingImgs: [], // 情景图
        infallibleTimesList: [],
        lowestProbability: '', // 最低概率
        reduceStep: '', // 递减概率
        reward: '', // 酬劳
        type: '' // 类型
      })
    },
    // 删除轮播
    removeList (index) {
      this.form.gifts.splice(index, 1)
    },
    // 新增奖品
    addPrize (index, index2) {
      this.form.gifts[index].attrLimitList.push({
        attrId: '', // 属性类型
        type: '', // 门槛类型
        value: '' // 门槛值
      })
    },
    // 删除奖品
    removePrize (index, index2) {
      this.form.gifts[index].attrLimitList.splice(index2, 1)
      this.form.gifts[index].attrLimitList.forEach((item3, index3) => {
        item3.index = index3
      })
    },
    // 新增跳转模块
    addjumpModal (index3) {
      this.form.skips.push({
        img: '',
        img2: [],
        Jumpurl: {
          url: null,
          id: null,
          classId: null,
          paramType: '0',
          value: ''
        },
        paramType: 0,
        paramValue: '', // 参数值
        skipLink: '', // 跳转地址
        skipType: '' // 跳转类型
      })
    },
    // 删除跳转模块
    removejumpModal (index3) {
      this.form.skips.splice(index3, 1)
    },
    // 添加时机
    getOpportunity (index, index2) {
      // console.log("index2", index, index2);
      this.form.gifts[index].infallibleTimesList2.push({
        infallibleTimew: ''
      })
    },
    // 删除时机
    getClosety (index, index2) {
      this.form.gifts[index].infallibleTimesList2.splice(index2, 1)
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
}
.ql-editor {
  padding: 0;
}

/deep/.el-form-item__content {
  display: flex !important;
}
/deep/.el-form-item__content {
  line-height: 40px;
}
/deep/.el-radio-group {
  line-height: 30px;
  padding-top: 10px;
}
.el-icon-delete:before {
  font-size: 21px;
  margin: 0 10px;
  color: red;
}
.btns[data-v-109c3efb] {
  margin-right: 12px;
}
.btns {
  margin-left: 10px;
}
</style>
